export default __webpack_public_path__ + "static/media/brainstorming-2.465df018.jpg";